import { useState, useCallback, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Select, FormControl, InputLabel, MenuItem, FormGroup, Table, TableBody, TableContainer, Grid, Button, Checkbox, FormControlLabel, Typography, TableCell, TableHead, TableRow } from '@mui/material';
import { SelectField, TextField, MultilineField, SearchSelectField, Autocomplete } from '../../style-guide';
import { sendRequest, REQUEST_ACTIONS } from '../../utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { snackbarToggle } from '../../reducers/snackbarSlicer';
import { setAdmin, onWarehouseChange, onPageChange, onSizeChange } from '../../reducers/admin-reducers/AdminSlicer';
import { Snackbar, Dialog } from '../../style-guide';
import imgHide from './hide.png'
import imgShow from './show.png'
import { URL, LANGUAGES, parcelSortBy, parcelStatusList, fclImportForeignCharges, paginationArr, fclCostLocalChargesExport } from '../../constants/global-constants';
import { addDesc, getUserInfoByLockerId, getDiscriptionsList, createShippingRequest, getParcelsList } from '../Admins/AdminHandler'

import { getProductChargesByProdShipCharge, getProductCharges1, addCrm } from '../../reducers/requestHandler';
import Accounts from './Accounts';
import AirImport from './AirImport';
const accountsData = [{ type: "Import Contact 1", name: "", position: "", mail: "", mobile: "", landline: "" }, { type: "Import Contact 2", name: "", position: "", mail: "", mobile: "", landline: "" }, { type: "Export Contact 1", name: "", position: "", mail: "", mobile: "", landline: "" }, { type: "Export Contact 2", name: "", position: "", mail: "", mobile: "", landline: "" }, { type: "Accounts", name: "", position: "", mail: "", mobile: "", landline: "" }, { type: "Manager level", name: "", position: "", mail: "", mobile: "", landline: "" }]
const AddCrm = props => {
    const dispatch = useDispatch();
    const { roles, paginationData, warehouseList, senderList, discriptionsList, adminList } = useSelector(state => state.admin);
    const { admin } = useSelector(state => state.session);
    const { listOfFunctionTypes, listOfAgentNetwork, listOfProductCategories, listOfShipmentTypes, listOfMeasurementUnits, listOfcurrency, listOfKgFactor, listOfAirLine, listOfLclExportImportAFs, listOfAirExportAFs, countryList, qsStatusList, listOfServiceType, listOfAirPort, listOfPort, listOfIncoterms, listOfFLCTypes40, listOfFLCTypes20, listOfProductCharges } = useSelector(state => state.parameter);
    const { snackbar } = useSelector(state => state.snackbar);
    const [userData, setUserData] = useState(null);
    const [bNextPage, setNextPage] = useState(false);
    
    const onSnackbarHandleClose = () => dispatch(snackbarToggle(false));
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const [value, setValue] = useState(
        props.data
            ? {
                id: props.data.id,
                accounts: props.data.accounts,
                address: props.data.address,
                agentId: props.data.agentId,
                charges: props.data.charges,
                companyName: props.data.companyName,
                countries: props.data.countries,
                countryId: props.data.countryId,
                createTime: props.data.createTime,
                crmId: props.data.crmId,
                freeText: props.data.freeText,
                functionId: props.data.functionId,
                networkId: props.data.networkId,
                updateTime: props.data.updateTime,
                sales: props.data.sales,
                vat: props.data.vat,
            }
            : {
                id: null,
                accounts: [],
                sales:null,
                address: null,
                agentId: 0,
                charges: {},
                companyName: null,
                countries: [],
                countryId: 0,
                createTime: 0,
                crmId: null,
                freeText: null,
                functionId: 0,
                networkId: 0,
                vat: "",
            },
    );
    const [salesList, setSalesList] = useState([]);
    useEffect(() => {
        var sList = adminList.filter(function (obj) {
            return obj.type == 3;
        }).map(pr => ({
            id: pr.id,
            name: pr.adminName
        }));
        setSalesList(sList);
    }, [adminList]);
    const backPage = () => {
        setNextPage(false);
        setUserData(null);
        value.token = "";
    };
    const nextPage = () => {
        setNextPage(true);
    };
    const isCreateShipmentDiasabled = () => {
        return (!value.token || !value.descId ||
            !value.serialNum || !value.weight || !value.length || !value.width ||
            !value.height || !value.packages);
    }
    const [accounts, setAccounts] = useState([]);
    const [checked, setChecked] = useState(false);
    const save = () => {
        var countries = [];
        for (var i = 0; i < selectedCountries.length; i++) {
            countries.push(selectedCountries[i].id);
        }
        var charges = {};
        if (value.functionId == 2) {
            
            charges = {
                "LCL_IMPORT": crmLclImports,
                "FCL_IMPORT": crmFclImports,
                "FCL_EXPORT": crmFclExports,
                "AIR_IMPORT": crmAirImports,
                "LOCAL_AIR_IMPORT": crmAirLocalImports,
                "LOCAL_AIR_EXPORT": crmAirLocalExport,
                "LOCAL_LCL_EXPORT": crmLclLocalExport,
                "LOCAL_LCL_IMPORT": crmLclLocalImports,
                "LOCAL_FCL_IMPORT": crmFclLocalImport,
                "LOCAL_FCL_EXPORT": crmFclLocalExport,
                "AGENT_CUSTOMS_CHARGES": crmAgentClientCharges,
                "AGENT_LOCAL_CHARGES": crmClientLocalCharges,
                "CUSTOM_AIR_IMPORT": crmCustomsChargesAirImport,
                "CUSTOM_LCL_IMPORT": crmCustomsChargesLclImport,
                "CUSTOM_LCL_EXPORT": crmCustomsChargesLclExport,
                "CUSTOM_FCL_EXPORT": crmCustomsChargesFclExport,
                "CUSTOM_FCL_IMPORT": crmCustomsChargesFclImport,
                "CUSTOM_AIR_EXPORT": crmCustomsChargesAirExport,
            }
        } else if (value.functionId == 1) {
            
            charges = {
                "CUSTOM_CHARGES": crmClientCharges,
                "CLIENT_LOCAL_CHARGES": crmClientLocalCharges,
                "LCL_IMPORT": crmLclImports,
                "FCL_IMPORT": crmFclImports,
                "FCL_EXPORT": crmFclExports,
                "AIR_IMPORT": crmAirImports,
                "LOCAL_AIR_IMPORT": crmAirLocalImports,
                "LOCAL_AIR_EXPORT": crmAirLocalExport,
                "LOCAL_LCL_EXPORT": crmLclLocalExport,
                "LOCAL_LCL_IMPORT": crmLclLocalImports,
                "LOCAL_FCL_IMPORT": crmFclLocalImport,
                "LOCAL_FCL_EXPORT": crmFclLocalExport,
                "AGENT_CUSTOMS_CHARGES": crmAgentClientCharges,
                "AGENT_LOCAL_CHARGES": crmClientLocalCharges,
                "CUSTOM_AIR_IMPORT": crmCustomsChargesAirImport,
                "CUSTOM_LCL_IMPORT": crmCustomsChargesLclImport,
                "CUSTOM_LCL_EXPORT": crmCustomsChargesLclExport,
                "CUSTOM_FCL_EXPORT": crmCustomsChargesFclExport,
                "CUSTOM_FCL_IMPORT": crmCustomsChargesFclImport,
                "CUSTOM_AIR_EXPORT": crmCustomsChargesAirExport,
            }
        } else if (value.functionId == 3) {
            
            charges = {
                "LOCAL_CHARGES": crmShippingLineCharges
            }
        } else if (value.functionId == 5) {
            
            charges = {
                "FOREIGN_CHARGES": crmCoLoaderForeignCharges,
                "COLODER_FRIEGHT_CHARGES": crmCoLoaderFrightCharges,
                "COLODER_EXPORT_FRIEGHT_CHARGES": crmExportCoLoaderFrightCharges,
                "COLODER_EXPORT_LOCAL_CHARGES": crmExportCoLoaderLocalCharges,
                "COLODER_IMPORT_LOCAL_CHARGES": crmImportCoLoaderLocalCharges,
            }
        } else if (value.functionId == 4) {
            
            charges = {
                "AIRLINE_FRIGHT_CHARGES_EXPORT": crmAirLineFrieghtChargesExport,
                "AIRLINE_FRIGHT_CHARGES_IMPORT": crmAirLineFrieghtChargesImport,
                "AIRLINE_LOCAL_CHARGES_IMPORT": crmAirLocalImports
            }
        }
        var data = {
            id: value.id,
            companyName: value.companyName,
            countryId: value.countryId,
            functionId: value.functionId,
            agentId: value.agentId,
            networkId: value.networkId,
            address: value.address,
            freeText: value.freeText,
            accounts: accounts,
            countries: countries,
            charges: charges,
            sales: value.sales,
            vat: value.vat,
        }
        addCrm(dispatch, snackbarToggle, data, admin, (id) => {
            props.callback(id);
        })

        props.onHandleCancel();
        props.setCrmFilter({
            CompanyName: "",
            FreeText: "",
            Address: "",
            CountryId: "",
            FunctionId: [],
            FunctionId1: -1,
        });

    };
    const [reloadKey, setReloadKey] = useState(1);
    const [lockerId, setLockerId] = useState("");
    const [statusId, setStatusId] = useState(parcelStatusList[0].id);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const resetShippingFilter = () => {

    };
    const update = () => {
        addCrm(dispatch, snackbarToggle, value, admin);
        props.onHandleCancel();
    };
    
    useEffect(() => {
        var tAccounts = [];
        for (var i = 0; i < value?.accounts?.length; i++) {
            var acc = { ...value?.accounts[i] }
            if (acc.type == 'Contact' && i == 0) {
                acc.type = "Import Contact 1"
            }
            if (acc.type == 'Contact' && i == 1) {
                acc.type = "Import Contact 2"
            }
            if (acc.type == 'Contact' && i == 2) {
                acc.type = "Export Contact 1"
            }
            if (acc.type == 'Contact' && i == 3) {
                acc.type = "Export Contact 2"
            }
            tAccounts.push(acc);
        }
        if (!tAccounts?.length) {
            var tAc = JSON.parse(JSON.stringify(accountsData));
            for (var j = 0; j < tAc.length; j++) {
                tAc[j].name = "";
                tAc[j].position = "";
                tAc[j].mail = "";
                tAc[j].mobile = "";
                tAc[j].landline = "";
            }
            setAccounts(tAc)
        } else {
            setAccounts(tAccounts)
        }
       // && value.accounts?.find(u => u.type === 'Import Contact 1')

        //setCrmFclExports([{ name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 }])
        if (!isLoaded && value.functionId && value.id) {
            setIsLoaded(true);

            if (value.functionId == 1) {
                if (props.data.charges) {
                    setCrmClientCharges(props.data.charges.CUSTOM_CHARGES)
                } else {
                    setImports(value.functionId);
                }
                if (props.data.charges?.CLIENT_LOCAL_CHARGES) {
                    setCrmClientLocalCharges(props.data.charges.CLIENT_LOCAL_CHARGES)
                } else {
                    setImports(value.functionId);
                }
                handleLocalChargesUpdate()
                
            }
            if (value.functionId == 2) {
               
                if (props.data.charges?.FCL_IMPORT) {
                    setCrmFclImports(props.data.charges.FCL_IMPORT)
                } else {
                    setImports(value.functionId);
                }
                if (props.data.charges?.LCL_IMPORT && props.data.charges?.AIR_IMPORT) {
                    setCrmLclImports(props.data.charges.LCL_IMPORT)
                    //setCrmFclImports(props.data.charges.FCL_IMPORT)
                    //setCrmFclExports(props.data.charges.FCL_EXPORT)
                    setCrmAirImports(props.data.charges.AIR_IMPORT)

                    procesCharges(function (data) {
                        var t = [...props.data.charges.AIR_IMPORT]

                        
                        //console.log("####################")
                        //console.log(data.data)
                        //console.log("####################")
                        for (var i = 0; i < data.data.length; i++) {

                            var bAdd = false;
                            for (var j = 0; j < t.length; j++) {
                                if (data.data[i].id == t[j].id || data.data[i].name == t[j].name) {
                                    bAdd = true;
                                    data.data[i].rate = 0;
                                    break;
                                }

                            }
                            if (!bAdd) {
                                if (data.data[i].name == 'THC' || data.data[i].name == 'Customs Clearance' || data.data[i].name == 'Screening' || data.data[i].name == 'Data Logger' || data.data[i].name == 'ATA Carnet' || data.data[i].name == 'Thermal Blanket' || data.data[i].name == 'Storage' || data.data[i].name == 'Cool-Box' || data.data[i].name == 'Packing' || data.data[i].name == 'Inland Freight' || data.data[i].name == 'IMO Handling' || data.data[i].name == 'Handling fee' || data.data[i].name == 'FCA Charges' || data.data[i].name == 'Expenses Abroad' || data.data[i].name == 'Due Carrier' || data.data[i].name == 'Due Agent' || data.data[i].name == 'Courier' || data.data[i].name == 'Documents' || data.data[i].name == 'Export Customs' || data.data[i].name == 'EUR1' || data.data[i].name == 'EXW Charges') {
                                    if (data.data[i].units.length) {
                                        data.data[i].unitOfMeasure = data.data[i].units[0]
                                    }
                                    if (data.data[i].currencies.length) {
                                        data.data[i].currency = data.data[i].currencies[0]
                                    }
                                    data.data[i].rate = 0
                                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                                }
                            }
                        }
                        setCrmAirImports(t)




                        var t1 = [...props.data.charges.LCL_IMPORT]
                        //console.log("####################")
                        //console.log(data.data)
                        //console.log("####################")
                        for (var i = 0; i < data.data.length; i++) {

                            var bAdd = false;
                            for (var j = 0; j < t1.length; j++) {
                                if (data.data[i].id == t1[j].id || data.data[i].name == t1[j].name) {
                                    bAdd = true;
                                    break;
                                }

                            }
                            if (!bAdd) {
                                if (data.data[i].name == 'Expenses Abroad' || data.data[i].name == 'EXW Charges' || data.data[i].name == 'Inland Freight' || data.data[i].name == 'B/L Fee' || data.data[i].name == 'Customs Inspection' || data.data[i].name == 'Due Agent' || data.data[i].name == 'Due Carrier' || data.data[i].name == 'EUR1' || data.data[i].name == 'Expenses Abroad' || data.data[i].name == 'Export Customs' || data.data[i].name == 'EXW Charges' || data.data[i].name == 'FCA Charges' || data.data[i].name == 'Handling fee' || data.data[i].name == 'IMO Handling' || data.data[i].name == 'Inland Freight' || data.data[i].name == 'OTCH' || data.data[i].name == 'Packing' || data.data[i].name == 'Stuffing') {
                                    if (data.data[i].units.length) {
                                        data.data[i].unitOfMeasure = data.data[i].units[0]
                                    }
                                    if (data.data[i].currencies.length) {
                                        data.data[i].currency = data.data[i].currencies[0]
                                    }
                                    data.data[i].rate = 0;
                                    t1.push(JSON.parse(JSON.stringify(data.data[i])));
                                }
                            }
                        }
                        setCrmLclImports(t1)

                    });
                }
                handleLocalChargesUpdate()
            }
            if (value.functionId == 3) {
                if (props.data.charges && props.data.charges?.LOCAL_CHARGES?.length==8) {
                    setCrmShippingLineCharges(props.data.charges.LOCAL_CHARGES)
                } else {
                    setImports(value.functionId);
                }
            }
            if (value.functionId == 5) {
                if (props.data.charges?.FOREIGN_CHARGES) {
                    setCrmCoLoaderForeignCharges(props.data.charges.FOREIGN_CHARGES)
                } else {
                    procesCharges(handleCoLoaderForeignCharges);
                }
                if (props.data.charges?.COLODER_FRIEGHT_CHARGES) {
                    setCrmCoLoaderFrightCharges(props.data.charges.COLODER_FRIEGHT_CHARGES)
                } else {
                    procesCharges(handleCoLoaderFrightCharges);
                }
                if (props.data.charges?.COLODER_EXPORT_FRIEGHT_CHARGES) {
                    setCrmExportCoLoaderFrightCharges(props.data.charges.COLODER_EXPORT_FRIEGHT_CHARGES)
                } else {
                    procesCharges(handleExportCoLoaderFrightCharges);
                }
                if (props.data.charges?.COLODER_EXPORT_LOCAL_CHARGES) {
                    setCrmExportCoLoaderLocalCharges(props.data.charges.COLODER_EXPORT_LOCAL_CHARGES)
                } else {
                    procesCharges(handleExportCoLoaderLocalCharges);

                }
                if (props.data.charges?.COLODER_IMPORT_LOCAL_CHARGES) {
                    setCrmImportCoLoaderLocalCharges(props.data.charges.COLODER_IMPORT_LOCAL_CHARGES)
                } else {
                    procesCharges(handleImportCoLoaderLocalCharges);
                }
            }
            if (value.functionId == 4) {
                if (props.data.charges?.AIRLINE_FRIGHT_CHARGES_EXPORT) {
                    setCrmAirLineFrieghtChargesExport(props.data.charges.AIRLINE_FRIGHT_CHARGES_EXPORT)
                } else {
                    setImports(value.functionId);
                }
                if (props.data.charges?.AIRLINE_FRIGHT_CHARGES_IMPORT) {
                    setCrmAirLineFrieghtChargesImport(props.data.charges.AIRLINE_FRIGHT_CHARGES_IMPORT)
                } else {
                    setImports(value.functionId);
                }
                if (props.data.charges?.AIRLINE_LOCAL_CHARGES_IMPORT) {
                    setCrmAirLocalImports(props.data.charges.AIRLINE_LOCAL_CHARGES_IMPORT)
                } else {
                    setImports(value.functionId);
                }
            }
            //setImports(value.functionId);
        }

    }, [reloadKey]);

    const getUserInfoByToken = (e) => {
        if (value.token && value.token.length < 4) {
            dispatch(snackbarToggle({ type: 'Error', message: 'Locker ID is too short, please check again.' }));
            return;
        }
        getUserInfoByLockerId(dispatch, value.token, admin, setUserData);
        //console.log(userData)
    }
    const keyPressed = (e) => {
        if (e.keyCode === 13) {
            getUserInfoByToken();

        }
    }

    const senderNameOptions = senderList.map(sender => ({
        id: sender.id,
        name: sender.senderName + ", " + sender.senderAddr + ", " + sender.senderCountry
    }));
    const descOptions = discriptionsList.map(desc => ({
        id: desc.id,
        name: desc.description
    }));
    const getVol = function () {
        if (!value.length || !value.width || !value.height) {
            return ""
        }
        return (Number(value.length) * Number(value.width) * Number(value.height)) / 5000000;
    }
    const getChargeableWeight = function () {
        if (!value.weight || !value.length || !value.width || !value.height) {
            return ""
        }
        if (Number(value.weight) > Number(value.length) * Number(value.width) * Number(value.height) / 5000) {
            return value.weight;
        } else {
            return Number(value.length) * Number(value.width) * Number(value.height) / 5000;
        }
    }

    const [isFilePicked, setIsFilePicked] = useState(false);
    const [uploadStarted, setUploadStarted] = useState(false);

    const changeHandler = (event) => {
        setUploadStarted(false);
        setIsFilePicked(true);
        var fileReader = new FileReader();

        fileReader.onload = function (fileLoadedEvent) {
            var base64String = fileReader.result.replace("data:", "").replace(/^.+,/, "");
            var t = {
                parcelImage: base64String,
                damaged: value.params.damaged,
            }
            setValue(prev => ({ ...prev, params: t }))
            setUploadStarted(true);

        }
        if (event.target.files[0])
            fileReader.readAsDataURL(event.target.files[0]);
    };

    const handleCallBack = () => {
        setUploadStarted(false);
        //setSelectedFile(null);
    }
    const [crmAirLocalImports, setCrmAirLocalImports] = useState([]);
    const [crmLclLocalImports, setCrmLclLocalImports] = useState([]);
    const [crmFclLocalImports, setCrmFclLocalImports] = useState([]);
    const [crmLclLocalExport, setCrmLclLocalExport] = useState([]);
    const [crmFclLocalExport, setCrmFclLocalExport] = useState([]);
    const [crmFclLocalImport, setCrmFclLocalImport] = useState([]);
    const [crmAirLocalExport, setCrmAirLocalExport] = useState([]);
    const [crmLclImports, setCrmLclImports] = useState([]);
    const [crmFclImports, setCrmFclImports] = useState([]);
    const [crmFclExports, setCrmFclExports] = useState([]);
    const [crmAirImports, setCrmAirImports] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    //const [bReset, setBReset] = useState(false);
    var bReset = false;
    const [bLclImport, setBlclImport] = useState(false);
    const [bLclExport, setBlclExport] = useState(false);
    const [bFclExport, setBfclExport] = useState(false);
    const [bFclImport, setBfclImport] = useState(false);
    const [bAirImport, setBairImport] = useState(true);
    const [bAirExport, setBairExport] = useState(false);
    const [bAirLocalImport, setBAirLocalImport] = useState(value.functionId == 2?false:true);
    const [bAirLocalExport, setBAirLocalExport] = useState(value.functionId == 2 ? true : false);
    const [bLclLocalImport, setBLclLocalImport] = useState(false);
    const [bLclLocalExport, setBLclLocalExport] = useState(false);
    const [bFclLocalExport, setBFclLocalExport] = useState(false);
    const [bFclLocalImport, setBFclLocalImport] = useState(false);
    const [bAirLineFrightImport, setBAirLineFrightImport] = useState(true);
    const [bAirLineFrightExport, setBAirLineFrightExport] = useState(false);
    const [bCustomAirImport, setBCustomAirImport] = useState(true);
    const [bCustomAirExport, setBCustomAirExport] = useState(false);
    const [bCustomLclImport, setBCustomLclImport] = useState(false);
    const [bCustomFclImport, setBCustomFclImport] = useState(false);
    const [bCustomLclExport, setBCustomLclExport] = useState(false);
    const [bCustomFclExport, setBCustomFclExport] = useState(false);
    const [bColoaderLocalExport, setBColoaderLocalExport] = useState(false);
    const [bColoaderLocalImport, setBColoaderLocalImport] = useState(true);
    var bA = 0;
    var bL = 0;
    var bF = 0;
    const hideAllAirLineFrightCharges = (event) => {
        setBAirLineFrightImport(false)
        setBAirLineFrightExport(false)
    }
    const hideAllColoaderLocalCharges = (event) => {
        setBColoaderLocalExport(false);
        setBColoaderLocalImport(false);
    }
    const hideAllCustomsCharges = (event) => {
        setBCustomAirImport(false)
        setBCustomAirExport(false)
        setBCustomLclImport(false)
        setBCustomLclExport(false)
        setBCustomFclExport(false)
        setBCustomFclImport(false)
    }
    const hideAllLocalCharges = (event) => {
        setBAirLocalImport(false)
        setBAirLocalExport(false)
        setBLclLocalImport(false)
        setBLclLocalExport(false)
        setBFclLocalExport(false)
        setBFclLocalImport(false)
    }
    const hideAllCharges = (event) => {
        setBfclExport(false);
        setBlclImport(false);
        setBlclExport(false);
        setBfclImport(false);
        setBairImport(false);
        setBairExport(false);
        bA = 0;
        bL = 0;
        bF = 0;
    }
    const handleLclForeignCharges = (event) => {
        hideAllCharges();
        setBlclImport(true);
        bL = 1;
        /*window.setTimeout(function () {
            setImports(value.functionId);
            setImports(value.functionId);},1)*/
        
    }
    const handleLclForeignChargesExport = (event) => {
        hideAllCharges();
        setBlclExport(true);
        bL = 1;
        /*window.setTimeout(function () {
            setImports(value.functionId);
            setImports(value.functionId);},1)*/
        
    }
    const handleFclForeignChargesExport = (event) => {
        hideAllCharges();
        bF = 1;
        setBfclExport(true);
        /*setImports(value.functionId);
        setImports(value.functionId);*/
    }
    const handleFclForeignCharges = (event) => {
        hideAllCharges();
        bF = 1;
        setBfclImport(true);
        /*setImports(value.functionId);
        setImports(value.functionId);*/
    }
    const handleAirForeignCharges = (event) => {
        hideAllCharges();
        setBairImport(true);
        bA = 1;
        /*setImports(value.functionId);
        setImports(value.functionId);*/
    }
    const handleAirForeignChargesExport = (event) => {
        hideAllCharges();
        setBairExport(true);
        //bA = 1;
       // setImports(value.functionId);
        //setImports(value.functionId);
    }
    const handleFunction = (event) => {
        setValue(prev => ({ ...prev, functionId: event.target.value }))
        setImports(event.target.value);
    }
    const getAirForeignChargesByName = function (name) {
        var t = [{ name: 'EXW Charges', unitOfMeasure: 2, currency: 2, rate: 0, min: 0 },
            { name: 'EUR1', unitOfMeasure: 2, currency: 2, rate: 0, min: 0 },
            { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'ATA Carnet', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Data Logger', unitOfMeasure: 2, currency: 2, rate: 0, min: 0 },
            { name: 'Courier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Due Agent', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Expenses Abroad', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'FCA Charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 },
            { name: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Packing', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Cool-Box', unitOfMeasure: 2, currency: 2, rate: 0, min: 0 },
            { name: 'Storage', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 },
            { name: 'Thermal Blanket', unitOfMeasure: 2, currency: 2, rate: 0, min: 0 },
        ]

        return t.find(u => u.name === name);
    }
    const getFclForeignChargesByName = function (name) {
        var t = [
            { name: 'Expenses Abroad', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate20: 0,rate40: 0, min: 0 },
            { name: 'Customs Inspection', unitOfMeasure: 2, currency: 1, rate20: 0,rate40: 0, min: 0 },
            { name: 'Data Logger', unitOfMeasure: 2, currency: 2, rate20: 0,rate40: 0, min: 0 },
            { name: 'Due Agent', unitOfMeasure: 2, currency: 1, rate20: 0,rate40: 0, min: 0 },
            { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate20: 0,rate40: 0, min: 0 },
            { name: 'Electricity', unitOfMeasure: 4, currency: 2, rate20: 0, rate20: 0, min: 0 },
            { name: 'EUR1', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'EXW Charges', unitOfMeasure: 2, currency: 1, rate20: 0,rate40: 0, min: 0 },
            { name: 'FCA Charges', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'Genset', unitOfMeasure:4, currency: 2, rate20: 0,rate40: 0, min: 0 },
            { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'IMO Handling', unitOfMeasure: 4, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'Inland Freight', unitOfMeasure: 4, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'OTHC', unitOfMeasure: 4, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'Packing', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'Stuffing', unitOfMeasure: 4, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'VGM', unitOfMeasure: 4, currency: 1, rate20: 0, rate40: 0, min: 0 }
        ]

        return t.find(u => u.name === name);
    }
    const getLCLForeignChargesByName = function (name) {
        var t = [{ name: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },


            { name: 'Customs Inspection', unitOfMeasure: 2, currency: 2, rate: 0, min: 0 },
             { name: 'Due Agent', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'EUR1', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Expenses Abroad', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'EXW Charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'FCA Charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 },
            { name: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'OTHC', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'Packing', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Stuffing', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }


            
            ]

        return t.find(u => u.name === name);
    }
    const procesCharges = function (callback) {
        var data = {
            data: [...listOfProductCharges]
        }
        
        callback(JSON.parse(JSON.stringify(data)))
    }
    const handleFlcImports = function (items) {
       // setCrmFclImports([])
        var t = []
        for (var i = 0; i < items.length; i++) {
            var itm = getFclForeignChargesByName(items[i].name)

            if (itm) {
                items[i].unitOfMeasure = items[i]?.units?.find(u => u === itm.unitOfMeasure)
                items[i].currency = items[i]?.currencies?.find(u => u === itm.currency)
            } else {
                if (items[i].units.length) {
                    items[i].unitOfMeasure = items[i].units[0]
                }
                if (items[i].currencies.length) {
                    items[i].currency = items[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (items[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = items[i].unitOfMeasure
                    t[j].currency = items[i].currency;
                    break;
                }

            }
            if (!bAdd) {
                //if (items[i].name == 'THC' || items[i].name == 'Customs Clearance' || items[i].name == 'Screening' || items[i].name == 'Data Logger' || items[i].name == 'ATA Carnet' || items[i].name == 'Thermal Blanket' || items[i].name == 'Storage' || items[i].name == 'Cool-Box' || items[i].name == 'Packing'  || items[i].name == 'Inland Freight' || items[i].name == 'IMO Handling' || items[i].name == 'Handling fee' || items[i].name == 'FCA Charges' || items[i].name == 'Expenses Abroad' ||  items[i].name == 'Due Carrier' || items[i].name == 'Due Agent' || items[i].name == 'Courier' || items[i].name == 'Documents' || items[i].name == 'Export Customs' || items[i].name == 'EUR1'|| items[i].name == 'EXW Charges') {
                if (itm) {
                    /*if (items[i].units.length) {
                        items[i].unitOfMeasure = items[i].units[0]
                    }
                    if (items[i].currencies.length) {
                        items[i].currency = items[i].currencies[0]
                    }*/
                    items[i].rate20 = 0;
                    items[i].rate40 = 0;
                    items[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(items[i])));
                }
            }
        }
         setCrmFclImports(JSON.parse(JSON.stringify(t)))
        window.setTimeout(function () {
            //setCrmFclImports(JSON.parse(JSON.stringify(t)))
        },10)
    }

    const [openOrderModalCopy, setOpenOrderModalCopy] = useState(false);

    const onHandleOpenModalCopy = () => {
        setOpenOrderModalCopy(true);
    };
    const onHandleCancelModalCopy = () => setOpenOrderModalCopy(false);

    const setImports = function (val) {
        
        if (val == 2) {
           // getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 3, function (data) {
            procesCharges(function (data) {
                var items = JSON.parse(JSON.stringify(data.data))
                //if (bLclImport || bL == 1) {
                    
                setTimeout(function () {
                    var t = []
                    //console.log("**************************")
                    //console.log(items)
                    //console.log("**************************")
                    for (var i = 0; i < items.length; i++) {
                        var itm = getLCLForeignChargesByName(items[i].name)
                        if (itm) {
                            items[i].unitOfMeasure = items[i]?.units?.find(u => u === itm.unitOfMeasure)
                            items[i].currency = items[i]?.currencies?.find(u => u === itm.currency)
                           // items[i].currency = itm.currency;
                        } else {
                            if (items[i].units.length) {
                                items[i].unitOfMeasure = items[i].units[0]
                            }
                            if (items[i].currencies.length) {
                                items[i].currency = items[i].currencies[0]
                            }
                        }
                        var bAdd = false;
                        for (var j = 0; j < t.length; j++) {
                            if (items[i].id == t[j].id) {
                                bAdd = true;
                                t[j].unitOfMeasure = items[i].unitOfMeasure
                                t[j].currency = items[i].currency;
                                break;
                            }

                        }
                        if (!bAdd) {
                            // if (items[i].name == 'Expenses Abroad' || items[i].name == 'EXW Charges' || items[i].name == 'Inland Freight') {
                            if (itm) {
                                /*if (items[i].units.length) {
                                    items[i].unitOfMeasure = items[i].units[0]
                                }
                                if (items[i].currencies.length) {
                                    items[i].currency = items[i].currencies[0]
                                }*/
                                items[i].rate = 0;
                                items[i].min = 0;
                                t.push(JSON.parse(JSON.stringify(items[i])));
                            }
                        }
                    }
                    setCrmLclImports(t)
                }, 10)
                //}
                if (bAirImport || bA == 1) {
                    // var t = [...crmAirImports]
                    var t = []
                    for (var i = 0; i < items.length; i++) {
                        var itm = getAirForeignChargesByName(items[i].name)
                        if (itm) {
                            items[i].unitOfMeasure = itm.unitOfMeasure
                            items[i].currency = itm.currency;
                        } else {
                            if (items[i].units.length) {
                                items[i].unitOfMeasure = items[i].units[0]
                            }
                            if (items[i].currencies.length) {
                                items[i].currency = items[i].currencies[0]
                            }
                        }
                        var bAdd = false;
                        for (var j = 0; j < t.length; j++) {
                            if (items[i].id == t[j].id) {
                                bAdd = true;
                                t[j].unitOfMeasure = items[i].unitOfMeasure
                                t[j].currency = items[i].currency;
                                break;
                            }

                        }
                        if (!bAdd) {
                            //if (items[i].name == 'THC' || items[i].name == 'Customs Clearance' || items[i].name == 'Screening' || items[i].name == 'Data Logger' || items[i].name == 'ATA Carnet' || items[i].name == 'Thermal Blanket' || items[i].name == 'Storage' || items[i].name == 'Cool-Box' || items[i].name == 'Packing'  || items[i].name == 'Inland Freight' || items[i].name == 'IMO Handling' || items[i].name == 'Handling fee' || items[i].name == 'FCA Charges' || items[i].name == 'Expenses Abroad' ||  items[i].name == 'Due Carrier' || items[i].name == 'Due Agent' || items[i].name == 'Courier' || items[i].name == 'Documents' || items[i].name == 'Export Customs' || items[i].name == 'EUR1'|| items[i].name == 'EXW Charges') {
                            if (itm) {
                                /*if (items[i].units.length) {
                                    items[i].unitOfMeasure = items[i].units[0]
                                }
                                if (items[i].currencies.length) {
                                    items[i].currency = items[i].currencies[0]
                                }*/
                                items[i].rate = itm.rate;
                                items[i].min = itm.min;
                                t.push(JSON.parse(JSON.stringify(items[i])));
                            }
                        }
                    }
                    setCrmAirImports(t)
                }
                //if (bFclImport || bF == 1) {
                handleFlcImports(items)
                //}
            });


           procesCharges( handleClientLocalCharges);
            procesCharges( handleAgentClientCharges);
            procesCharges( handleAgentLocalChargesLCLImport);
            procesCharges(handleAgentLocalChargesFCLImport);

            procesCharges( handleAgentLocalChargesImport);
            procesCharges( handleAgentLocalChargesExport);



            procesCharges( handleCustomsChargesAirExport);
            procesCharges( handleCustomsChargesAirImport);
            procesCharges( handleCustomsChargesLclImport);
            procesCharges( handleCustomsChargesLclExport);
            procesCharges(handleClientLocalCharges);
            procesCharges(handleCustomsChargesFclExport);
            procesCharges(handleCustomsChargesFclImport);

            procesCharges(handleForeignChargesFclExport);
            /*
            getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 2, handleClientLocalCharges);
            getProductCharges1(dispatch, admin, handleAgentClientCharges);
            getProductCharges1(dispatch, admin, handleAgentLocalChargesLCLImport);
            getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 2, handleAgentLocalChargesImport);
            getProductCharges1(dispatch, admin, handleAgentLocalChargesExport);



            getProductCharges1(dispatch, admin, handleCustomsChargesAirExport);
            getProductCharges1(dispatch, admin, handleCustomsChargesAirImport);
            getProductCharges1(dispatch, admin, handleCustomsChargesLclImport);
            getProductCharges1(dispatch, admin, handleCustomsChargesLclExport);
            getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 2, handleClientLocalCharges);
*/

        } else if (val == 1) {
            procesCharges( handleClientCharges);
           /* procesCharges( handleClientCharges);
            procesCharges( handleClientCharges);
            procesCharges( handleClientCharges);
            procesCharges( handleClientCharges);
            procesCharges( handleClientCharges);*/


            procesCharges( handleClientLocalCharges);
            procesCharges( handleAgentClientCharges);
            procesCharges( handleAgentLocalChargesLCLImport);
            procesCharges( handleAgentLocalChargesImport);
            procesCharges( handleAgentLocalChargesExport);
            procesCharges(handleAgentLocalChargesFCLImport);

            procesCharges( handleCustomsChargesAirExport);
            procesCharges( handleCustomsChargesAirImport);
            procesCharges( handleCustomsChargesLclImport);
            procesCharges(handleCustomsChargesLclExport);
            procesCharges(handleCustomsChargesFclExport);
            procesCharges(handleCustomsChargesFclImport);
            procesCharges(handleCustomsChargesLclImport);
            /*
            getProductChargesByProdShipCharge(dispatch, admin, 1, 1, 4, handleClientCharges);
            getProductChargesByProdShipCharge(dispatch, admin, 1, 2, 4, handleClientCharges);
            getProductChargesByProdShipCharge(dispatch, admin, 1, 3, 4, handleClientCharges);
            getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 4, handleClientCharges);
            getProductChargesByProdShipCharge(dispatch, admin, 2, 2, 4, handleClientCharges);
            getProductChargesByProdShipCharge(dispatch, admin, 2, 3, 4, handleClientCharges);


            getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 2, handleClientLocalCharges);
            getProductCharges1(dispatch, admin, handleAgentClientCharges);
            getProductCharges1(dispatch, admin, handleAgentLocalChargesLCLImport);
            getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 2, handleAgentLocalChargesImport);
            getProductCharges1(dispatch, admin, handleAgentLocalChargesExport);


            getProductCharges1(dispatch, admin, handleCustomsChargesAirExport);
            getProductCharges1(dispatch, admin, handleCustomsChargesAirImport);
            getProductCharges1(dispatch, admin, handleCustomsChargesLclImport);
            getProductCharges1(dispatch, admin, handleCustomsChargesLclExport);
*/
           // getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 2, handleClientLocalCharges);
        } else if (val == 3) {
            procesCharges( handleShippingLineCharges);
           // getProductCharges1(dispatch, admin, handleShippingLineCharges);
        } else if (val == 4) {
           

            procesCharges( handleAgentLocalChargesImport);
            procesCharges( handleAirLineFrieghtChargesImport);
            procesCharges(handleAirLineFrieghtChargesExport);
            /*
            getProductCharges1(dispatch, admin, handleAgentLocalChargesImport);
            getProductCharges1(dispatch, admin, handleAirLineFrieghtChargesImport);
            getProductChargesByProdShipCharge(dispatch, admin, 1, 1, 1, handleAirLineFrieghtChargesExport);
*/
        } else if (val == 5) {
            procesCharges(handleCoLoaderForeignCharges);
            procesCharges(handleCoLoaderFrightCharges);
            procesCharges(handleExportCoLoaderFrightCharges);
            procesCharges( handleExportCoLoaderLocalCharges);
            procesCharges( handleImportCoLoaderLocalCharges);
            /*
            getProductChargesByProdShipCharge(dispatch, admin, 2, 1, 3, handleCoLoaderForeignCharges);
            getProductChargesByProdShipCharge(dispatch, admin, 2, 2, 1, handleCoLoaderFrightCharges);
            getProductChargesByProdShipCharge(dispatch, admin, 1, 2, 1, handleExportCoLoaderFrightCharges);
            getProductCharges1(dispatch, admin, handleExportCoLoaderLocalCharges);
            getProductCharges1(dispatch, admin, handleImportCoLoaderLocalCharges);
*/
        }
    }
    const [crmClientLocalCharges, setCrmClientLocalCharges] = useState([]);
    const [crmCustomsChargesLclExport, setCrmCustomsChargesLclExport] = useState([]);
    const [crmCustomsChargesFclExport, setCrmCustomsChargesFclExport] = useState([]);
    const [crmCustomsChargesLclImport, setCrmCustomsChargesLclImport] = useState([]);
    const [crmCustomsChargesFclImport, setCrmCustomsChargesFclImport] = useState([]);
    const [crmCustomsChargesAirImport, setCrmCustomsChargesAirImport] = useState([]);
    const [crmCustomsChargesAirExport, setCrmCustomsChargesAirExport] = useState([]);
    const [crmAgentClientCharges, setCrmAgentClientCharges] = useState([]);
    const [crmClientCharges, setCrmClientCharges] = useState([]);
    const [crmClientCharges1, setCrmClientCharges1] = useState([]);
    const [crmAirLocalImportLikeClient, setCrmAirLocalImportLikeClient] = useState([]);
    const handleAgentLocalChargesLikeClient = (data) => {
        var t = [...crmAgentClientCharges]
        for (var i = 0; i < data.data.length; i++) {
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (!bAdd) {
                if (data.data[i].name == 'Due Carrier' || data.data[i].name == 'Handling fee' || data.data[i].name == 'IMO Handling' || data.data[i].name == 'Import Handling' || data.data[i].name == 'Inland Freight' || data.data[i].name == 'It Charge' || data.data[i].name == 'Storage') {
                    if (data.data[i].units.length) {
                        data.data[i].unitOfMeasure = data.data[i].units[0]
                    }
                    if (data.data[i].currencies.length) {
                        data.data[i].currency = data.data[i].currencies[0]
                    }
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmAgentClientCharges(t)
       // setCrmClientCharges1(t)
    }
    const getImportLocalChargesItemByName = (name) => {
        var localChargesItems =  [{ name: 'Delivery Order', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'IATA Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Communication', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'ATA Carnet', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'Data Logger', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 },
            { name: 'Import Handling', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'It Charge', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Storage', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }]
       return  localChargesItems.find(u => u.name === name);
    }
    const getColoaderExportLocalChargesItemByName = (name) => {
        var localChargesItems = [{ name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'OTHC', unitOfMeasure: 3, currency: 4, rate: 0, min: 0 }, { name: 'Port fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'BL fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Global Gate Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'C.O.O', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Communication', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'ATA Carnet', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Courier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 }, { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'EUR1', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'EBS', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 }, { name: 'Export License', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'Insurance Handling', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'It Charge', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Lift on', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 }, { name: 'Packing', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Storage', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'Stuffing', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Warehouse handling fee', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'VGM', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 }, { name: 'Customs Inspection', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'EXW Charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'AWB Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }]
       return  localChargesItems.find(u => u.name === name);
    }
    const getColoaderImportLocalChargesItemByName = (name) => {
        var localChargesItems = [{ name: 'Delivery Order', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Communication', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Congestion', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 }, { name: 'DTHC', unitOfMeasure: 3, currency: 4, rate: 0, min: 0 }, { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'ISPS', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'It Charge', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Local charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Port fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'UnStuffing', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }]
       return  localChargesItems.find(u => u.name === name);
    }
    const getExportLocalChargesItemByName = (name) => {
        var localChargesItems = [{
            name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0
        }, { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Terminal fee', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'Global Gate Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Courier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Customs Clearance', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'AWB Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Airline IT charge', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Bank fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'C.O.O', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'ATA Carnet', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Cool-Box', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Data Logger', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'EUR1', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Insurance Handling', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Packing', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Thermal Blanket', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Storage', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'Customs Inspection', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Export License', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'EXW Charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }]

       return  localChargesItems.find(u => u.name === name?.trim());
    }

    
    const getFclExportLocalChargesItemByName = (name) => {
        
        return fclCostLocalChargesExport.find(u => u.name === name?.trim());
    }
    const getLclExportLocalChargesItemByName = (name) => {
        var localChargesItems = [{ name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 }, { name: 'OTHC', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'Port fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'BL fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Global Gate Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'C.O.O', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Communication', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'ATA Carnet', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Courier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Customs Clearance', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'EUR1', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'EBS', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 }, { name: 'Export License', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'IMO Handling', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Insurance Handling', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'It Charge', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Lift on', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 }, { name: 'Packing', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Storage', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'Stuffing', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }, { name: 'Warehouse handling fee', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'VGM', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 }, { name: 'Customs Inspection', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'EXW Charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'AWB Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }]
       return  localChargesItems.find(u => u.name === name?.trim());
    }
    const getLclImportLocalChargesItemByName = (name) => {
        var localChargesItems = [{ name: 'Delivery Order', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 }, { name: 'B/L Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Communication', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Congestion', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 }, { name: 'DTHC', unitOfMeasure: 3, currency: 4, rate: 0, min: 0 }, { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 }, { name: 'Inland Freight', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'ISPS', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 }, { name: 'It Charge', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Local charges', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'Port fees', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 }, { name: 'UnStuffing', unitOfMeasure: 5, currency: 1, rate: 0, min: 0 }]
       return  localChargesItems.find(u => u.name === name?.trim());
    }
    const getFclImportLocalChargesItemByName = (name) => {
        var localChargesItems = [
    { name: 'Monitoring', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Local charges', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'PSS', unitOfMeasure: 3, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'ISPS', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'IEI', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Electricity', unitOfMeasure: 4, currency: 2, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'DTHC', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Delivery Order', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Congestion', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Cleaning', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Handling fee', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Port fees', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Inland Freight', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'BL fees', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Global Gate Fee', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'C.O.O', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Communication', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'ATA Carnet', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Collection Fee', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Courier', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Due Carrier', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'EUR1', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Export Customs', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'EBS', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Export License', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'IMO Handling', unitOfMeasure: 1, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Insurance Handling', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'It Charge', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Lift on', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Packing', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Storage', unitOfMeasure: 1, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Stuffing', unitOfMeasure: 5, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'UnStuffing', unitOfMeasure: 5, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Warehouse handling fee', unitOfMeasure: 3, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'VGM', unitOfMeasure: 4, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'Customs Inspection', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'EXW Charges', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "", min: 0 },
    { name: 'AWB Fee', unitOfMeasure: 2, currency: 1, rate40: 0, rate20: 0, remark: "",  min: 0 }];
       return  localChargesItems.find(u => u.name === name?.trim());
    }
    const handleAgentLocalChargesImport = (data) => {
        var t1 = []
        for (var i = 0; i < data.data.length; i++) {
           
            var bAdd1 = false;
            for (var j = 0; j < t1.length; j++) {
                if (data.data[i].name == t1[j].name) {
                    bAdd1 = true;
                    break;
                }

            }
            if (!bAdd1) {
                var item = getImportLocalChargesItemByName(data.data[i].name)             
                if (item) {
                    var tItem = { ...data.data[i], rate: item.rate, min: item.min, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate = 0
                    tItem.min = 0
                    t1.push(JSON.parse(JSON.stringify(tItem)));
                }
                
            }
        }

        t1 = uniqueByKey(t1, "id")
        setCrmAirLocalImports(t1)
    }
    const handleAgentLocalChargesLCLImport = (data) => {
        var t = [...crmLclLocalImports]
        var t1 = [...crmLclLocalExport]
        var t2 = [...crmFclLocalExport]
        if (crmFclLocalExport.length != fclCostLocalChargesExport.length) {
            t2 = [];
        }
        var t3 = [...crmFclLocalImport]

        if (bReset) {
            t = []
            t1 = []
            t2 = []
            t3 = []
        }
        for (var i = 0; i < data.data.length; i++) {

            var bAdd3 = false;
            for (var j = 0; j < t3.length; j++) {
                if (data.data[i].id == t3[j].id) {
                    bAdd3 = true;
                    break;
                }

            }
            var bAdd2 = false;
            for (var j = 0; j < t2.length; j++) {
                if (data.data[i].id == t2[j].id) {
                    bAdd2 = true;
                    break;
                }

            }
            var bAdd1 = false;
            for (var j = 0; j < t1.length; j++) {
                if (data.data[i].id == t1[j].id) {
                    bAdd1 = true;
                    break;
                }

            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (data.data[i].units.length) {
                data.data[i].unitOfMeasure = data.data[i].units[0]
            }
            if (data.data[i].currencies.length) {
                data.data[i].currency = data.data[i].currencies[0]
            }
            if (!bAdd) {
                var item = getLclImportLocalChargesItemByName(data.data[i].name);
                if (item) {
                    var tItem = { ...data.data[i], rate: 0, min: 0, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate = 0
                    tItem.min = 0
                    t.push(JSON.parse(JSON.stringify(tItem)));
                }
            }
            if (!bAdd1) {

                var item = getLclExportLocalChargesItemByName(data.data[i].name);
                if (item) {
                    var tItem = { ...data.data[i], rate: 0, min: 0, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate = 0
                    tItem.min = 0
                    t1.push(JSON.parse(JSON.stringify(tItem)));
                }

            }
            if (!bAdd2) {

                var item = getFclExportLocalChargesItemByName(data.data[i].name);
                if (item) {
                    var tItem = { ...data.data[i], rate: 0, min: 0, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate20 = 0
                    tItem.rate40 = 0
                    tItem.min = 0
                    t2.push(JSON.parse(JSON.stringify(tItem)));
                }

            }
            if (!bAdd3) {

                var item = getFclImportLocalChargesItemByName(data.data[i].name);
                if (item) {
                    var tItem = { ...data.data[i], rate: 0, min: 0, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate20 = 0
                    tItem.rate40 = 0
                    tItem.min = 0
                    t3.push(JSON.parse(JSON.stringify(tItem)));
                }

            }
        }

        t = uniqueByKey(t, "id")
        t1 = uniqueByKey(t1, "id")
        t2 = uniqueByKey(t2, "id")
        t3 = uniqueByKey(t3, "id")
        setCrmLclLocalImports(t)
        setCrmFclLocalImports(t)
        setCrmLclLocalExport(t1)

        setCrmFclLocalExport(t2)
        //setCrmFclLocalImport(t3)
    }
    const handleAgentLocalChargesFCLImport = (data) => {
        
        var t3 = [...crmFclLocalImport]
        if (bReset) {
            t3 = []
        }
        for (var i = 0; i < data.data.length; i++) {

            var bAdd3 = false;
            for (var j = 0; j < t3.length; j++) {
                if (data.data[i].id == t3[j].id) {
                    bAdd3 = true;
                    break;
                }

            }
           
            if (data.data[i].units.length) {
                data.data[i].unitOfMeasure = data.data[i].units[0]
            }
            if (data.data[i].currencies.length) {
                data.data[i].currency = data.data[i].currencies[0]
            }
            
            if (!bAdd3) {

                var item = getFclImportLocalChargesItemByName(data.data[i].name);
                if (item) {
                    var tItem = { ...data.data[i], rate: 0, min: 0, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate20 = 0
                    tItem.rate40 = 0
                    tItem.min = 0
                    t3.push(JSON.parse(JSON.stringify(tItem)));
                }

            }
        }

        t3 = uniqueByKey(t3, "id")
        setCrmFclLocalImport(t3)
    }
    const handleAgentLocalChargesExport = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].name == t[j].name) {
                    bAdd = true;
                    break;
                }

            }
           
            if (!bAdd) {
                //console.log(data.data[i].name)
                var item = getExportLocalChargesItemByName(data.data[i].name)
                if (item) {
                    var tItem = { ...data.data[i], rate: 0, min: 0, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate = 0
                    tItem.min = 0
                    t.push(JSON.parse(JSON.stringify(tItem)));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmAirLocalExport(t)
    }
    const handleClientLocalCharges = (data) => {
        var items = JSON.parse(JSON.stringify(data.data))
        var t = []
        for (var i = 0; i < items.length; i++) {
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (items[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (!bAdd) {
                if (items[i].name == 'Delivery Order' || items[i].name == 'Communication' || items[i].name == 'ATA Carnet' || items[i].name == 'Collection Fee' || items[i].name == 'Customs Clearance' || items[i].name == 'Data Logger' || items[i].name == 'Due Carrier' || items[i].name == 'Handling fee' || items[i].name == 'IMO Handling' || items[i].name == 'Import Handling' || items[i].name == 'Inland Freight' || items[i].name == 'It Charge' || items[i].name == 'Storage') {
                     if (items[i].units.length) {
                        items[i].unitOfMeasure = items[i].units[0]
                    }
                    if (items[i].currencies.length) {
                        items[i].currency = items[i].currencies[0]
                    }
                    items[i].rate = 0;
                    t.push(JSON.parse(JSON.stringify(items[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmClientLocalCharges(t)
    }
    const handleClientCharges = (data) => {
        var t = [...crmClientCharges]
        if (bReset) {
            t = [];
        }
        for (var i = 0; i < data.data.length; i++) {
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (!bAdd) {
                if (data.data[i].name == 'Customs Clearance' || data.data[i].name == 'Formalities' || data.data[i].name == 'World Gate' || data.data[i].name == 'Insurance Handling' || data.data[i].name == 'Inland Freight' || data.data[i].name == 'Import License') {
                    if (data.data[i].units.length) {
                        data.data[i].unitOfMeasure = data.data[i].units[0]
                    }
                    if (data.data[i].currencies.length) {
                        data.data[i].currency = data.data[i].currencies[0]
                    }
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmClientCharges(t)
        setCrmClientCharges1(t)
    }
    const handleAgentClientCharges = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (!bAdd) {
                if (data.data[i].name == 'Customs Clearance' || data.data[i].name == 'Formalities' || data.data[i].name == 'World Gate' || data.data[i].name == 'Insurance Handling'  || data.data[i].name == 'Inland Freight' || data.data[i].name == 'Import License') {
                    if (data.data[i].units.length) {
                        data.data[i].unitOfMeasure = data.data[i].units[0]
                    }
                    if (data.data[i].currencies.length) {
                        data.data[i].currency = data.data[i].currencies[0]
                    }
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmAgentClientCharges(t)
    }
    const getCustomsChargesAirImportByName = function (name) {
        var t = [
            { name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'Formalities', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'World Gate', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Insurance Handling', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'Inland Freight', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'Import License', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
        ]

        return t.find(u => u.name === name);
    }
    const getCustomsChargesLclImportByName = function (name) {
        var t = [
            { name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'Formalities', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'World Gate', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Insurance Handling', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'Inland Freight', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
            { name: 'Import License', unitOfMeasure: 2, currency: 4, rate: 0, min: 0 },
        ]

        return t.find(u => u.name === name);
    }
    const getCustomsChargesFcl = function (name) {
        var t = [
            { name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate20: 0, rate40: 0, min: 0 },
            { name: 'Formalities', unitOfMeasure: 2, currency: 4, rate20: 0, rate40: 0, min: 0 },
            { name: 'World Gate', unitOfMeasure: 2, currency: 1, rate20: 0, rate40: 0, min: 0 },
            { name: 'Insurance Handling', unitOfMeasure: 2, currency: 4, rate20: 0, rate40: 0, min: 0 },
            { name: 'Inland Freight', unitOfMeasure: 2, currency: 4, rate20: 0, rate40: 0, min: 0 },
            { name: 'Import License', unitOfMeasure: 2, currency: 4, rate20: 0, rate40: 0, min: 0 },
        ]

        return t.find(u => u.name === name);
    }
    const handleCustomsChargesAirImport = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getCustomsChargesAirImportByName(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = data.data[i]?.currencies?.find(u => u === itm.currency)//itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
                if (itm) {
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmCustomsChargesAirImport(t)
    }
    const handleCustomsChargesLclImport = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getCustomsChargesLclImportByName(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = data.data[i]?.currencies?.find(u => u === itm.currency)//itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {

                if (itm) {
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmCustomsChargesLclImport(t)
    }
    const handleCustomsChargesLclExport = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getCustomsChargesLclImportByName(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = data.data[i]?.currencies?.find(u => u === itm.currency)//itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
               
                if (itm) {
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmCustomsChargesLclExport(t)
    }
    const handleCustomsChargesFclExport = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getCustomsChargesFcl(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = data.data[i]?.currencies?.find(u => u === itm.currency)//itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
               
                if (itm) {
                    data.data[i].rate20 = 0;
                    data.data[i].rate40 = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmCustomsChargesFclExport(t)
    }
    const handleCustomsChargesFclImport = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getCustomsChargesFcl(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = data.data[i]?.currencies?.find(u => u === itm.currency)//itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
               
                if (itm) {
                    data.data[i].rate20 = 0;
                    data.data[i].rate40 = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmCustomsChargesFclImport(t)
    }

    const handleCustomsChargesAirExport = (data) => {
       var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getCustomsChargesAirImportByName(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = data.data[i]?.currencies?.find(u => u === itm.currency)//itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                     bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {       

                if (itm) {
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmCustomsChargesAirExport(t)
    }
    function uniqueByKey(array, key) {
        return [...new Map(array.map((x) => [x[key], x])).values()];
    }
    const [crmShippingLineCharges, setCrmShippingLineCharges] = useState([]);
    const [crmCoLoaderForeignCharges, setCrmCoLoaderForeignCharges] = useState([]);
    const [crmAirLineFrieghtChargesExport, setCrmAirLineFrieghtChargesExport] = useState([]);
    const [crmAirLineFrieghtChargesImport, setCrmAirLineFrieghtChargesImport] = useState([]);
    const [crmCoLoaderFrightCharges, setCrmCoLoaderFrightCharges] = useState([]);
    const [crmExportCoLoaderFrightCharges, setCrmExportCoLoaderFrightCharges] = useState([]);
    const [crmExportCoLoaderLocalCharges, setCrmExportCoLoaderLocalCharges] = useState([]);
    const [crmImportCoLoaderLocalCharges, setCrmImportCoLoaderLocalCharges] = useState([]);


    const getAirLineFrieghtChargesExportByName = function (name) {
        var t = [
                { name: 'Airfreight', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 },
            { name: 'AMS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Airline Surcharges', unitOfMeasure: 1, currency: 1, rate: 0, min: 0 },
            { name: 'IMO', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Airline DGR fee', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
                ]

        return t.find(u => u.name === name);
    }
    const handleAirLineFrieghtChargesExport = (data) => {
        var t = [...crmAirLineFrieghtChargesExport]
        if (bReset) {
            t = []
        }
        for (var i = 0; i < data.data.length; i++) {

            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (!bAdd) {
                if (data.data[i].name == 'Airfreight' ||data.data[i].name == 'AMS' || data.data[i].name == 'Airline Surcharges' || data.data[i].name == 'IMO' || data.data[i].name == 'Airline DGR fee') {
                    if (data.data[i].units.length) {
                        data.data[i].unitOfMeasure = data.data[i].units[0]
                    }
                    if (data.data[i].currencies.length) {
                        data.data[i].currency = data.data[i].currencies[0]
                    }
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }
        t = uniqueByKey(t, "id")
        setCrmAirLineFrieghtChargesExport(t)
    }

    const handleAirLineFrieghtChargesImport = (data) => {
        var t = [...crmAirLineFrieghtChargesImport]
        if (bReset) {
            t = []
        }
        for (var i = 0; i < data.data.length; i++) {

            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (!bAdd) {

                if (data.data[i].name == 'Airfreight' || data.data[i].name == 'Inland Freight' || data.data[i].name == 'IMO' || data.data[i].name == 'Airline Surcharges') {
                    if (data.data[i].units.length) {
                        data.data[i].unitOfMeasure = data.data[i].units[0]
                    }
                    if (data.data[i].currencies.length) {
                        data.data[i].currency = data.data[i].currencies[0]
                    }
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }
        t = uniqueByKey(t, "id")
        setCrmAirLineFrieghtChargesImport(t)
    }
    const getCoLoaderFrightChargesByName = function (name) {
        var t = [
            { name: 'BAF', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'Congestion', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'ESS', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'IMO', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Low Sulphur Fuel', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'PSS', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'WAR Risk', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
        ]

        return t.find(u => u.name === name);
    }
    const handleCoLoaderFrightCharges = (data) => {
        
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getCoLoaderFrightChargesByName(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
                if (itm) {
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }
        t = uniqueByKey(t, "id")
        setCrmCoLoaderFrightCharges(t)
    }
    const getExportCoLoaderFrightChargesByName = function (name) {
        var t = [
            { name: 'BAF', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'Congestion', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'ESS', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'IMO', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Low Sulphur Fuel', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'PSS', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'AMS', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'ISPS', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
            { name: 'WAR Risk', unitOfMeasure: 3, currency: 1, rate: 0, min: 0 },
        ]

        return t.find(u => u.name === name);
    }
    const handleExportCoLoaderFrightCharges = (data) => {
        
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getExportCoLoaderFrightChargesByName(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
                 if (itm) {
                     data.data[i].rate = 0;
                     data.data[i].min = 0;
                     t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }
        t = uniqueByKey(t, "id")
        setCrmExportCoLoaderFrightCharges(t)
    }
    const handleExportCoLoaderLocalCharges = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {

            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (!bAdd) {
                var item = getColoaderExportLocalChargesItemByName(data.data[i].name)
                if (item) {
                    var tItem = { ...data.data[i], rate: item.rate, min: item.min, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate = 0
                    tItem.min = 0
                    t.push(JSON.parse(JSON.stringify(tItem)));
                }
            }
        }
        t = uniqueByKey(t, "id")
        setCrmExportCoLoaderLocalCharges(t)
    }
    const handleImportCoLoaderLocalCharges = (data) => {
        var t = [...crmImportCoLoaderLocalCharges]
        if (bReset) {
            t = []
        }
        for (var i = 0; i < data.data.length; i++) {

            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    break;
                }

            }
            if (!bAdd) {
                var item = getColoaderImportLocalChargesItemByName(data.data[i].name)
                if (item) {
                    var tItem = { ...data.data[i], rate: item.rate, min: item.min, currency: item.currency, unitOfMeasure: item.unitOfMeasure }
                    tItem.rate = 0
                    tItem.min = 0
                    t.push(JSON.parse(JSON.stringify(tItem)));
                }
            }
        }
        t = uniqueByKey(t, "id")
        setCrmImportCoLoaderLocalCharges(t)
    }
    const handleCoLoaderForeignCharges = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getLCLForeignChargesByName(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
                if (itm) {
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }
        t = uniqueByKey(t, "id")
        setCrmCoLoaderForeignCharges(t)
    }

    const getShippingLineChargesByName = function (name) {
        var t = [
            { name: 'BAF', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'Congestion', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'ESS', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'IMO', unitOfMeasure: 2, currency: 1, rate: 0, min: 0 },
            { name: 'Low Sulphur Fuel', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'Over weight', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'PSS', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
            { name: 'WAR Risk', unitOfMeasure: 4, currency: 1, rate: 0, min: 0 },
        ]

        return t.find(u => u.name === name);
    }
    const handleShippingLineCharges = (data) => {
       
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = getShippingLineChargesByName(data.data[i].name)
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
                if (itm) {
                    data.data[i].rate = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }
        t = uniqueByKey(t, "id")
        setCrmShippingLineCharges(t)
    }
    const handleLocalChargesUpdate = (data) => {
        if (props.data.charges?.FCL_EXPORT) {
            setCrmAirLocalImports(props.data.charges.FCL_EXPORT)
        } else {
            procesCharges(handleForeignChargesFclExport);
        }
        if (props.data.charges?.LOCAL_AIR_IMPORT) {
            setCrmAirLocalImports(props.data.charges.LOCAL_AIR_IMPORT)
        } else {
            procesCharges( handleAgentLocalChargesImport);
        }
        if (props.data.charges?.LOCAL_AIR_EXPORT) {
            setCrmAirLocalExport(props.data.charges.LOCAL_AIR_EXPORT)
        } else {
            procesCharges(handleAgentLocalChargesExport);
        }
        if (props.data.charges?.LOCAL_LCL_EXPORT) {
            setCrmLclLocalExport(props.data.charges.LOCAL_LCL_EXPORT)

        } else {
            procesCharges( handleAgentLocalChargesLCLImport);
        }
        if (props.data.charges?.LOCAL_LCL_IMPORT) {
            setCrmLclLocalImports(props.data.charges.LOCAL_LCL_IMPORT)

        } else {
            procesCharges( handleAgentLocalChargesLCLImport);
        }
        if (props.data.charges?.LOCAL_FCL_IMPORT) {
            setCrmFclLocalImports(props.data.charges.LOCAL_FCL_IMPORT)

        } else {
            procesCharges( handleAgentLocalChargesLCLImport);
        }
        if (props.data.charges?.LOCAL_FCL_IMPORT) {
            setCrmFclLocalImport(props.data.charges.LOCAL_FCL_IMPORT)

        } else {
            procesCharges( handleAgentLocalChargesLCLImport);
        }
        //console.log(fclCostLocalChargesExport)
        

        if (props.data.charges?.LOCAL_FCL_EXPORT) {
            setCrmFclLocalExport(props.data.charges.LOCAL_FCL_EXPORT);

        } else {
            procesCharges(handleAgentLocalChargesFCLImport);
        }
        if (props.data.charges?.CUSTOM_AIR_EXPORT) {
            setCrmCustomsChargesAirExport(props.data.charges.CUSTOM_AIR_EXPORT)

        } else {
            procesCharges(handleCustomsChargesAirExport);
        }
        if (props.data.charges?.CUSTOM_AIR_IMPORT) {
            setCrmCustomsChargesAirImport(props.data.charges.CUSTOM_AIR_IMPORT)

        } else {
            procesCharges( handleCustomsChargesAirImport);
        }
        if (props.data.charges?.CUSTOM_LCL_IMPORT) {
            setCrmCustomsChargesLclImport(props.data.charges.CUSTOM_LCL_IMPORT)

        } else {
            procesCharges( handleCustomsChargesLclImport);
        }
        if (props.data.charges?.CUSTOM_LCL_EXPORT) {
            setCrmCustomsChargesLclExport(props.data.charges.CUSTOM_LCL_EXPORT)

        } else {
            procesCharges( handleCustomsChargesLclExport);
        }
        if (props.data.charges?.CUSTOM_FCL_EXPORT) {
            setCrmCustomsChargesFclExport(props.data.charges.CUSTOM_FCL_EXPORT)

        } else {
            procesCharges(handleCustomsChargesFclImport);
        }
        if (props.data.charges?.CUSTOM_FCL_IMPORT) {
            setCrmCustomsChargesFclImport(props.data.charges.CUSTOM_FCL_IMPORT)

        } else {
            procesCharges(handleCustomsChargesFclExport);

        }
        if (props.data.charges?.AGENT_CUSTOMS_CHARGES) {
            setCrmAgentClientCharges(props.data.charges.AGENT_CUSTOMS_CHARGES)

        } else {
            procesCharges( handleAgentClientCharges);
        }
        if (props.data.charges?.AGENT_LOCAL_CHARGES) {
            setCrmClientLocalCharges(props.data.charges.AGENT_LOCAL_CHARGES)
        } else {
            procesCharges( handleClientLocalCharges);
        }
        
    }
    const handleForeignChargesFclExport = (data) => {
        var t = []
        for (var i = 0; i < data.data.length; i++) {
            var itm = [{ name: 'Customs Clearance', unitOfMeasure: 2, currency: 4, rate20: 0, rate40: 0, min: 0 }].find(u => u.name === data.data[i].name);
            if (itm) {
                data.data[i].unitOfMeasure = data.data[i]?.units?.find(u => u === itm.unitOfMeasure)
                data.data[i].currency = data.data[i]?.currencies?.find(u => u === itm.currency)//itm.currency;
            } else {
                if (data.data[i].units.length) {
                    data.data[i].unitOfMeasure = data.data[i].units[0]
                }
                if (data.data[i].currencies.length) {
                    data.data[i].currency = data.data[i].currencies[0]
                }
            }
            var bAdd = false;
            for (var j = 0; j < t.length; j++) {
                if (data.data[i].id == t[j].id) {
                    bAdd = true;
                    t[j].unitOfMeasure = data.data[i].unitOfMeasure
                    t[j].currency = data.data[i].currency;
                    break;
                }

            }
            if (!bAdd) {
                if (itm) {
                    data.data[i].rate20 = 0;
                    data.data[i].rate40 = 0;
                    data.data[i].min = 0;
                    t.push(JSON.parse(JSON.stringify(data.data[i])));
                }
            }
        }

        t = uniqueByKey(t, "id")
        setCrmFclExports(t)
    }
    
    const handleParams = (event) => {
    }
    const handleSubmission = () => {
        setUploadStarted(false);
        var fileInput = document.getElementById('file');
        var element = document.getElementById("file_container");
        if (fileInput) {
            element.removeChild(fileInput);
        }
        var x = document.createElement("INPUT");
        x.setAttribute("type", "file");
        x.setAttribute("id", 'file');
        x.style.display = "none";
        element.appendChild(x);

        document.getElementById("file").addEventListener("change", changeHandler, true);
        document.getElementById('file').click();

    };
    const [countriesOpt, setCountriesOpt] = useState([...countryList]);
    const [selectedCountries, setSelecteCountries] = useState([]);
    const handleCountriesOpt = (event, data) => {
        var t = []
        var selected = [...selectedCountries]
        for (var i = 0; i < selected.length; i++) {
            var tObj = JSON.parse(JSON.stringify(selected[i]));
            if (selected[i].id == data.id) {
                if (event.target.checked) {
                  // selected.push(tObj)
                } else {
                    selected.splice(i, 1);
                }
            }
        }
        for (var i = 0; i < countriesOpt.length; i++) {
            var tObj = JSON.parse(JSON.stringify(countriesOpt[i]));
            if (countriesOpt[i].id == data.id) {                
                tObj.bSelected = event.target.checked
                if (event.target.checked)
                 selected.push(tObj)
            }
            t.push(tObj)
        }
        setCountriesOpt(t);
        setSelecteCountries(selected);
    }
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    return (
        <Grid container item spacing={2} key={reloadKey}>
                <Grid container item spacing={2}>
                    
                    {<SelectField
                        required
                        value={value.countryId}
                        lg={5.5}
                        onChange={event => setValue(prev => ({ ...prev, countryId: event.target.value }))}
                        label='Country'
                        options={countryList}
                    />}
                    <TextField
                        required
                        lg={5.5}
                        value={value.companyName}
                        label='company Name'
                        onChange={event => setValue(prev => ({ ...prev, companyName: event.target.value }))}
                    />
                {<Grid item lg={5.5}>
                    <FormControl fullWidth>
                        <InputLabel sx={{ top: -6, maxWidth: 'calc(100% - 40px)' }}>
                            {'Function Type'}
                        </InputLabel>
                        <Select
                            value={value.functionId || ''}
                            label={'Function Type'}
                            onChange={handleFunction}
                            size='small'
                        >
                            {listOfFunctionTypes?.map(option => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.lable}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>}
                    {<Grid item lg={5.5}>
                    <Autocomplete

                        value={value.sales}
                        lg={12}

                        onChange={event => setValue(prev => ({ ...prev, sales: event.target.value }))}
                        label='Salesman'
                        options={salesList}
                    />
                    </Grid>}
                    {value.functionId == 2 && <TextField
                        lg={5.5}
                        value={value.agentId}
                        label='Id'
                        onChange={event => setValue(prev => ({ ...prev, agentId: event.target.value }))}
                    />}
                    {value.functionId == 2 &&
                    <Grid item lg={5.5}>
                            <FormControl fullWidth>
                                <InputLabel sx={{ top: -6, maxWidth: 'calc(100% - 40px)' }}>
                                    {'Network'}
                                </InputLabel>
                                <Select
                                    value={value.networkId || ''}
                                    label={'Network'}
                                    onChange={event => setValue(prev => ({ ...prev, networkId: event.target.value }))}
                                    size='small'
                                >
                                    {listOfAgentNetwork?.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.lable}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>



                }
                <TextField
                    lg={5.5}
                    value={value.address}
                    label='Address'
                    onChange={event => setValue(prev => ({ ...prev, address: event.target.value }))}
                />
                <TextField
                    lg={5.5}
                    value={value.vat}
                    label='VAT'
                    onChange={event => setValue(prev => ({ ...prev, vat: event.target.value }))}
                />
                    {<TableContainer>
                    <Table padding={'normal'} size={ 'small'}>
                            <TableHead>
                                <TableRow>
                                <TableCell >
                                    <Typography variant='h7' style={{ width: '3vw' }}>
                                            Type
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                    <Typography variant='h7' style={{ width: '3vw' }}>
                                        Name
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                    <Typography variant='h7' style={{ width: '3vw' }}>
                                        Position
                                        </Typography>
                                    </TableCell>
                                <TableCell style={{ width: '3vw' }}>
                                        <Typography variant='h7'>
                                        Mail
                                        </Typography>
                                    </TableCell>
                                <TableCell style={{ width: '3vw' }}>
                                        <Typography variant='h7'>
                                        Mobile
                                        </Typography>
                                    </TableCell>
                                <TableCell style={{ width: '3vw' }}>
                                        <Typography variant='h7'>
                                        Landline
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {accounts.length > 0 &&
                                accounts.map((account, index) => (

                                    <Accounts  accounts={accounts} data={account} index={index} setAccounts={setAccounts}/>
                                        
                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}
                    <MultilineField
                    xs={12}
                    sm={null}
                    md={null}
                    lg={null}
                    label='Free Text'
                    value={value.freeText}
                    onChange={event => setValue(prev => ({ ...prev, freeText: event.target.value }))}
                    
                />
                
                {value.functionId == 2 && <Grid container item id="file_container" style={{ marginLeft: 0, marginTop: 0 }} lg={5} md={5}>
                    
                    <Grid item lg={12} style={{  color:'green', marginTop: 11, borderRadius: 5 }}>
                        <FormControl fullWidth size={'small'} >
                            <InputLabel sx={{ top: 0, maxWidth: 'calc(100% - 25px)', fontSize: '0.8rem' }} >
                                Countries
                            </InputLabel>
                            <Select
                                value={''}
                                label={'Countries'}
                                size='small'
                                MenuProps={{ sx: { maxHeight: '50vh', fontSize: '0.8rem' } }}
                                style={{ maxWidth: '300px !important' }}
                            >
                               
                                {countriesOpt?.map(option => (
                                    <MenuItem key={option.id} value={option.id}>
                                        <FormControlLabel   control={<Checkbox checked={option.bSelected} onChange={event => handleCountriesOpt(event, option)} />} label={option.name}  />
                                    </MenuItem>
                                ))}
                                   
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                }
                {value.functionId == 2&&false && <Grid container item id="file_container" style={{  color: 'green', marginTop: 30, borderRadius: 5 }}>
                    {<Button sx={{ mt: -4, mb: 4, ml: 2 }} onClick={handleParams} variant='text' style={{ background: 'white' }}>
                        Selected Countries
                    </Button>}

                    <Grid item lg={12} style={{ marginTop: -30 }}>
                        {selectedCountries?.map(option => (
                            < Button sx={{ mt: 1, ml: 2, mb: 1 }} onClick={handleParams} variant='contained' >
                                {option.name}
                            </Button>
                        ))}
                    </Grid>
                </Grid>}
                {value.functionId == 2 && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>

                    <Grid item lg={12} >
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleParams} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Foreign Charges
                        </Button>}
                        </Grid>
                    <Grid item lg={12} sx={{ mt: 2 }}>
                       
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleAirForeignCharges} variant='contained' style={{ background: bAirImport ? 'green' : '#1565c0' }}>
                            Air Import
                        </Button>}
                        {false&&<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleAirForeignChargesExport} variant='contained' style={{ background: bAirExport ? 'green' : '#1565c0' }}>
                            Air Export
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleLclForeignCharges} variant='contained' style={{ background: bLclImport ? 'green' : '#1565c0' }}>
                            Lcl Import 
                        </Button>}
                        {false &&<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleLclForeignChargesExport} variant='contained' style={{ background: bLclExport ? 'green' : '#1565c0' }}>
                            Lcl Export
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleFclForeignCharges} variant='contained' style={{ background: bFclImport ? 'green' : '#1565c0' }}>
                            Fcl Import
                        </Button>}
                        {false &&<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleFclForeignChargesExport} variant='contained' style={{ background: bFclExport ? 'green' : '#1565c0' }}>
                            Fcl Export
                        </Button>}
                    </Grid>
                    {< TableContainer >
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    {!(bFclImport || bFclExport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>}
                                    {(bFclImport || bFclExport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate20
                                        </Typography>
                                    </TableCell>}
                                    {(bFclImport || bFclExport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate40
                                        </Typography>
                                    </TableCell>}
                                    {!(bFclImport || bFclExport) && <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>}
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {value.functionId == 2 && bAirImport && crmAirImports.length > 0 &&
                                    crmAirImports.map((account, index) => (
                                        <AirImport  crmAirImports={crmAirImports} data={account} index={index} setCrmAirImports={setCrmAirImports} />

                                    ))
                                }
                                {value.functionId == 2 && bAirExport && crmAirImports.length > 0 &&
                                    <TableRow>
                                        <TableCell colspan={ 7}>
                                        <Typography variant='h7'>
                                                <Grid container item justifyContent="center" style={{ width: "100%" ,color:"red"}}> No Charges</Grid>

                                        </Typography>
                                    </TableCell>
                                    </TableRow>
                                }
                                {value.functionId == 2 && bLclExport && crmAirImports.length > 0 &&
                                    <TableRow>
                                        <TableCell colspan={ 7}>
                                        <Typography variant='h7'>
                                                <Grid container item justifyContent="center" style={{ width: "100%" ,color:"red"}}> No Charges</Grid>

                                        </Typography>
                                    </TableCell>
                                    </TableRow>
                                }
                                {value.functionId == 2 && bLclImport && crmLclImports.length > 0 &&
                                    crmLclImports.map((account, index) => (
                                        <AirImport  crmAirImports={crmLclImports} data={account} index={index} setCrmAirImports={setCrmLclImports} />

                                    ))
                                }
                                {value.functionId == 2 && bFclImport && crmFclImports.length > 0 &&
                                    crmFclImports.map((account, index) => (
                                        <AirImport fcl={true}  crmAirImports={crmFclImports} data={account} index={index} setCrmAirImports={setCrmFclImports} />

                                    ))
                                }
                                {value.functionId == 2 && bFclExport && crmFclExports.length > 0 &&
                                    crmFclExports.map((account, index) => (
                                        <AirImport  fcl={ true} crmAirImports={crmFclExports} data={account} index={index} setCrmAirImports={setCrmFclExports} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }

                {(value.functionId == 1) && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                    {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleParams} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                        Local Charges
                    </Button>}
                    <Grid item lg={12} sx={{mt:2}}>
                        
                        
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBAirLocalExport(true)
                        }} variant='contained' style={{ background: bAirLocalExport ? 'green' : '#1565c0' }}>
                            Air Export
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBAirLocalImport(true)
                        }} variant='contained' style={{ background: bAirLocalImport ? 'green' : '#1565c0' }}>
                            Air Import
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBLclLocalImport(true)
                        }} variant='contained' style={{ background: bLclLocalImport ? 'green' : '#1565c0' }}>
                            Lcl Import
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBLclLocalExport(true)
                        }} variant='contained' style={{ background: bLclLocalExport ? 'green' : '#1565c0' }}>
                            Lcl Export
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBFclLocalImport(true)
                            if (!crmFclLocalImport.length) {
                                procesCharges(handleAgentLocalChargesFCLImport);
                            }
                        }} variant='contained' style={{ background: bFclLocalImport ? 'green' : '#1565c0' }}>
                            Fcl Import
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBFclLocalExport(true)
                        }} variant='contained' style={{ background: bFclLocalExport ? 'green' : '#1565c0' }}>
                            Fcl Export
                        </Button>}
                        
                    </Grid>
                    {< TableContainer >
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    {!(bFclLocalExport || bFclLocalImport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>}
                                    {(bFclLocalExport || bFclLocalImport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate20
                                        </Typography>
                                    </TableCell>}
                                    {(bFclLocalExport || bFclLocalImport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate40
                                        </Typography>
                                    </TableCell>}
                                    {!(bFclLocalExport || bFclLocalImport) && <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>}
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { bAirLocalImport && crmAirLocalImports.length > 0 &&
                                    crmAirLocalImports.map((account, index) => (
                                        <AirImport  crmAirImports={crmAirLocalImports} data={account} index={index} setCrmAirImports={setCrmAirLocalImports} />

                                    ))
                                }
                                { bAirLocalExport && crmAirLocalExport.length > 0 &&
                                    crmAirLocalExport.map((account, index) => (
                                        <AirImport  crmAirImports={crmAirLocalExport} data={account} index={index} setCrmAirImports={setCrmAirLocalExport} />

                                    ))
                                }
                                { bLclLocalImport && crmLclLocalImports.length > 0 &&
                                    crmLclLocalImports.map((account, index) => (
                                        <AirImport  crmAirImports={crmLclLocalImports} data={account} index={index} setCrmAirImports={setCrmLclLocalImports} />

                                    ))
                                }
                                { bLclLocalExport && crmLclLocalExport.length > 0 &&
                                    crmLclLocalExport.map((account, index) => (
                                        <AirImport  crmAirImports={crmLclLocalExport} data={account} index={index} setCrmAirImports={setCrmLclLocalExport} />

                                    ))
                                }
                                {bFclLocalExport && crmFclLocalExport.length > 0 &&
                                    crmFclLocalExport.map((account, index) => (
                                        <AirImport fcl={ true} crmAirImports={crmFclLocalExport} data={account} index={index} setCrmAirImports={setCrmFclLocalExport} />

                                    ))
                                }
                                {bFclLocalImport && crmFclLocalImport.length > 0 &&
                                    crmFclLocalImport.map((account, index) => (
                                        <AirImport fcl={true} crmAirImports={crmFclLocalImport} data={account} index={index} setCrmAirImports={setCrmFclLocalImport} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {(value.functionId == 2) && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                    {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={handleParams} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                        Local Charges
                    </Button>}
                    <Grid item lg={12} sx={{mt:2}}>
                        
                        {false&&<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBAirLocalImport(true)
                        }} variant='contained' style={{ background: bAirLocalImport ? 'green' : '#1565c0' }}>
                            Air Import
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBAirLocalExport(true)
                        }} variant='contained' style={{ background: bAirLocalExport ? 'green' : '#1565c0' }}>
                            Air Export
                        </Button>}
                        {false &&<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBLclLocalImport(true)
                        }} variant='contained' style={{ background: bLclLocalImport ? 'green' : '#1565c0' }}>
                            Lcl Import
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBLclLocalExport(true)
                        }} variant='contained' style={{ background: bLclLocalExport ? 'green' : '#1565c0' }}>
                            Lcl Export
                        </Button>}
                        {false &&<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBFclLocalImport(true)
                        }} variant='contained' style={{ background: bFclLocalImport ? 'green' : '#1565c0' }}>
                            Fcl Import
                        </Button>}
                        {<Button sx={{ mt: -2, mb: 2, ml: 2 }} onClick={() => {
                            hideAllLocalCharges();
                            setBFclLocalExport(true)
                        }} variant='contained' style={{ background: bFclLocalExport ? 'green' : '#1565c0' }}>
                            Fcl Export
                        </Button>}
                        
                    </Grid>
                    {< TableContainer >
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    {!(bFclLocalExport || bFclLocalImport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>}
                                    {(bFclLocalExport || bFclLocalImport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate20
                                        </Typography>
                                    </TableCell>}
                                    {(bFclLocalExport || bFclLocalImport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate40
                                        </Typography>
                                    </TableCell>}
                                    {!(bFclLocalExport || bFclLocalImport) && <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>}
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { bAirLocalImport && crmAirLocalImports.length > 0 &&
                                    crmAirLocalImports.map((account, index) => (
                                        <AirImport  crmAirImports={crmAirLocalImports} data={account} index={index} setCrmAirImports={setCrmAirLocalImports} />

                                    ))
                                }
                                { bAirLocalExport && crmAirLocalExport.length > 0 &&
                                    crmAirLocalExport.map((account, index) => (
                                        <AirImport  crmAirImports={crmAirLocalExport} data={account} index={index} setCrmAirImports={setCrmAirLocalExport} />

                                    ))
                                }
                                { bLclLocalImport && crmLclLocalImports.length > 0 &&
                                    crmLclLocalImports.map((account, index) => (
                                        <AirImport  crmAirImports={crmLclLocalImports} data={account} index={index} setCrmAirImports={setCrmLclLocalImports} />

                                    ))
                                }
                                { bLclLocalExport && crmLclLocalExport.length > 0 &&
                                    crmLclLocalExport.map((account, index) => (
                                        <AirImport  crmAirImports={crmLclLocalExport} data={account} index={index} setCrmAirImports={setCrmLclLocalExport} />

                                    ))
                                }
                                {bFclLocalExport && crmFclLocalExport.length > 0 &&
                                    crmFclLocalExport.map((account, index) => (
                                        <AirImport fcl={ true} crmAirImports={crmFclLocalExport} data={account} index={index} setCrmAirImports={setCrmFclLocalExport} />

                                    ))
                                }
                                {bFclLocalImport && crmFclLocalImport.length > 0 &&
                                    crmFclLocalImport.map((account, index) => (
                                        <AirImport fcl={true} crmAirImports={crmFclLocalImport} data={account} index={index} setCrmAirImports={setCrmFclLocalImport} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {(value.functionId == 1 || value.functionId == 2) && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                    
                    {<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                        Custom Charges
                    </Button>}
                    {< TableContainer >
                        
                        {false&&<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllCustomsCharges();
                            setBCustomAirImport(true)
                        }} variant='contained' style={{ background: bCustomAirImport ? 'green' : '#1565c0' }}>
                           Air Import
                        </Button>}
                        {false &&<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllCustomsCharges();
                            setBCustomAirExport(true)
                        }} variant='contained' style={{ background: bCustomAirExport ? 'green' : '#1565c0' }}>
                          Air Export
                        </Button>}
                        {false &&<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllCustomsCharges();
                            setBCustomLclImport(true)
                        }} variant='contained' style={{ background: bCustomLclImport ? 'green' : '#1565c0' }}>
                          LCL Import
                        </Button>}
                        {false &&<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllCustomsCharges();
                            setBCustomLclExport(true)
                        }} variant='contained' style={{ background: bCustomLclExport ? 'green' : '#1565c0' }}>
                          LCL Export
                        </Button>}
                        {false &&<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllCustomsCharges();
                            setBCustomFclImport(true)
                        }} variant='contained' style={{ background: bCustomFclImport ? 'green' : '#1565c0' }}>
                          FCL Import
                        </Button>}
                        {false &&<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllCustomsCharges();
                            setBCustomFclExport(true)
                        }} variant='contained' style={{ background: bCustomFclExport ? 'green' : '#1565c0' }}>
                          FCL Export
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    {!(bCustomFclImport || bCustomFclExport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>}
                                    {(bCustomFclImport || bCustomFclExport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate20
                                        </Typography>
                                    </TableCell>}
                                    {(bCustomFclImport || bCustomFclExport) && <TableCell>
                                        <Typography variant='h7'>
                                            Rate40
                                        </Typography>
                                    </TableCell>}
                                    
                                    {!(bCustomFclImport || bCustomFclExport) && <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>}
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bCustomAirExport && crmCustomsChargesAirExport.length > 0 &&
                                    crmCustomsChargesAirExport.map((account, index) => (
                                        <AirImport  crmAirImports={crmCustomsChargesAirExport} data={account} index={index} setCrmAirImports={setCrmCustomsChargesAirExport} />

                                    ))
                                }
                                {bCustomAirImport && crmCustomsChargesAirImport.length > 0 &&
                                    crmCustomsChargesAirImport.map((account, index) => (
                                        <AirImport  crmAirImports={crmCustomsChargesAirImport} data={account} index={index} setCrmAirImports={setCrmCustomsChargesAirImport} />

                                    ))
                                }

                                {bCustomLclImport && crmCustomsChargesLclImport.length > 0 &&
                                    crmCustomsChargesLclImport.map((account, index) => (
                                        <AirImport  crmAirImports={crmCustomsChargesLclImport} data={account} index={index} setCrmAirImports={setCrmCustomsChargesLclImport} />

                                    ))
                                }

                                {bCustomLclExport && crmCustomsChargesLclExport.length > 0 && <>
                                    
                                    {crmCustomsChargesLclExport.map((account, index) => (
                                        <AirImport  crmAirImports={crmCustomsChargesLclExport} data={account} index={index} setCrmAirImports={setCrmCustomsChargesLclExport} />

                                    ))}</>
                                }
                                {bCustomFclImport && crmCustomsChargesFclImport.length > 0 &&
                                    crmCustomsChargesFclImport.map((account, index) => (
                                        <AirImport fcl={true} crmAirImports={crmCustomsChargesFclImport} data={account} index={index} setCrmAirImports={setCrmCustomsChargesFclImport} />

                                    ))
                                }
                                {bCustomFclExport && crmCustomsChargesFclExport.length > 0 &&
                                    crmCustomsChargesFclExport.map((account, index) => (
                                        <AirImport fcl={true} crmAirImports={crmCustomsChargesFclExport} data={account} index={index} setCrmAirImports={setCrmCustomsChargesFclExport} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 1 &&false && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                    
                   
                    {< TableContainer >
                        {<Button onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Custom Charges
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {crmClientCharges.length > 0 &&
                                    crmClientCharges.map((account, index) => (
                                        <AirImport  crmAirImports={crmClientCharges} data={account} index={index} setCrmAirImports={setCrmClientCharges} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 2&&false && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                    
                   
                    {< TableContainer >
                        {<Button onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Custom Charges
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {crmAgentClientCharges.length > 0 &&
                                    crmAgentClientCharges.map((account, index) => (
                                        <AirImport  crmAirImports={crmAgentClientCharges} data={account} index={index} setCrmAirImports={setCrmAgentClientCharges} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {(false) && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                {/*{(value.functionId == 1 || value.functionId == 2) && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>*/}
                    
                   
                    {< TableContainer >
                        {<Button onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            {value.functionId == 1 ? 'Local Charges' :'Local Charges As Client'} 
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {crmClientLocalCharges.length > 0 &&
                                    crmClientLocalCharges.map((account, index) => (
                                        <AirImport  crmAirImports={crmClientLocalCharges} data={account} index={index} setCrmAirImports={setCrmClientLocalCharges} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 3&&false && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                   
                   
                    {< TableContainer >
                        {<Button onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Shipping line Charges
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {crmShippingLineCharges.length > 0 &&
                                    crmShippingLineCharges.map((account, index) => (
                                        <AirImport  crmAirImports={crmShippingLineCharges} data={account} index={index} setCrmAirImports={setCrmShippingLineCharges} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 5 && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                   
                   
                    {< TableContainer >
                        {<Button onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none",marginBottom:"15px" }}>
                            Foreign Charges
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {crmCoLoaderForeignCharges?.length > 0 &&
                                    crmCoLoaderForeignCharges?.map((account, index) => (
                                        <AirImport  crmAirImports={crmCoLoaderForeignCharges} data={account} index={index} setCrmAirImports={setCrmCoLoaderForeignCharges} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 5&&false && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                   
                   
                    {< TableContainer >
                        {<Button onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Fright Charges Import
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {crmCoLoaderFrightCharges?.length > 0 &&
                                    crmCoLoaderFrightCharges?.map((account, index) => (
                                        <AirImport  crmAirImports={crmCoLoaderFrightCharges} data={account} index={index} setCrmAirImports={setCrmCoLoaderFrightCharges} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 5 &&false && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                   
                   
                    {< TableContainer >
                        {<Button onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Fright Charges Export
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {crmExportCoLoaderFrightCharges?.length > 0 &&
                                    crmExportCoLoaderFrightCharges?.map((account, index) => (
                                        <AirImport  crmAirImports={crmExportCoLoaderFrightCharges} data={account} index={index} setCrmAirImports={setCrmExportCoLoaderFrightCharges} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 5 &&false && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                   
                   
                    {< TableContainer >
                        {<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Local Charges 
                        </Button>}
                        {<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllColoaderLocalCharges();
                            setBColoaderLocalImport(true)
                        }} variant='contained' style={{ background: bColoaderLocalImport ? 'green' : '#1565c0' }}>
                            Import 
                        </Button>}
                        {<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllColoaderLocalCharges();
                            setBColoaderLocalExport(true)
                        }} variant='contained' style={{ background: bColoaderLocalExport ? 'green' : '#1565c0' }}>
                            Export 
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bColoaderLocalExport && crmExportCoLoaderLocalCharges?.length > 0 &&
                                    crmExportCoLoaderLocalCharges?.map((account, index) => (
                                        <AirImport  crmAirImports={crmExportCoLoaderLocalCharges} data={account} index={index} setCrmAirImports={setCrmExportCoLoaderLocalCharges} />

                                    ))
                                }
                                {bColoaderLocalImport && crmImportCoLoaderLocalCharges?.length > 0 &&
                                    crmImportCoLoaderLocalCharges?.map((account, index) => (
                                        <AirImport  crmAirImports={crmImportCoLoaderLocalCharges} data={account} index={index} setCrmAirImports={setCrmImportCoLoaderLocalCharges} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 4 && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                   
                   
                    {< TableContainer >
                        {<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Fright Charges
                        </Button>}
                        {<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllAirLineFrightCharges(); 
                            setBAirLineFrightImport(true)
                        }} variant='contained' style={{ background: bAirLineFrightImport ? 'green' : '#1565c0' }}>
                            Import
                        </Button>}
                        {<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={() => {
                            hideAllAirLineFrightCharges();
                            setBAirLineFrightExport(true)
                        }} variant='contained' style={{ background: bAirLineFrightExport ? 'green' : '#1565c0' }}>
                            Export
                        </Button>}
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bAirLineFrightExport && crmAirLineFrieghtChargesExport?.length > 0 &&
                                    crmAirLineFrieghtChargesExport?.map((account, index) => (
                                        <AirImport  crmAirImports={crmAirLineFrieghtChargesExport} data={account} index={index} setCrmAirImports={setCrmAirLineFrieghtChargesExport} />

                                    ))
                                }
                                {bAirLineFrightImport &&crmAirLineFrieghtChargesImport?.length > 0 &&
                                    crmAirLineFrieghtChargesImport?.map((account, index) => (
                                        <AirImport  crmAirImports={crmAirLineFrieghtChargesImport} data={account} index={index} setCrmAirImports={setCrmAirLineFrieghtChargesImport} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                {value.functionId == 4 && <Grid container item id="file_container" style={{  marginTop: 20, borderRadius: 5 }}>
                   
                   
                    {< TableContainer >
                        {<Button sx={{ mt: 0, mb: 2, ml: 2 }} onClick={setBairImport} variant='outlined' style={{ background: 'white', color: "black", fontWeight: "bold", textTransform: "none" }}>
                            Local Charges
                        </Button>}
                        
                        <Table padding={'normal'} size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell >
                                        <Typography variant='h7'>
                                            Product
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Unit of Measure
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Currency
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Rate
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Min
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant='h7'>
                                            Remark
                                        </Typography>
                                    </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {crmAirLocalImports?.length > 0 &&
                                    crmAirLocalImports?.map((account, index) => (
                                        <AirImport  crmAirImports={crmAirLocalImports} data={account} index={index} setCrmAirImports={setCrmAirLocalImports} />

                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>}

                </Grid>
                }
                <Dialog open={openOrderModalCopy} title={"Reset charges"} onHandleCancel={onHandleCancelModalCopy}>
                    <Grid container item justifyContent='center' lg={12} spacing={2} style={{ width: "30vw", marginBottom: "20px", marginTop: "20px" }}>
                        Are you sure you want to reset charges.
                    </Grid>
                    {<Grid container item justifyContent='center' lg={12}>
                        <Button variant='contained' sx={{ mt: 2, mr: 2 }} onClick={() => {
                            //window.setTimeout(function () {
                                //setBReset(true)
                                bReset = true;
                            setCrmLclImports([])
                            setCrmFclImports([])
                            setCrmFclExports([])
                            setCrmAirImports([])
                            setCrmAirLocalImports([])
                            setCrmAirLocalExport([])
                            setCrmLclLocalExport([])
                            setCrmLclLocalImports([])
                            setCrmFclLocalImport([])
                            setCrmFclLocalExport([])
                            setCrmAgentClientCharges([])
                            setCrmClientLocalCharges([])
                            setCrmCustomsChargesAirImport([])
                            setCrmCustomsChargesLclImport([])
                            setCrmCustomsChargesLclExport([])
                            setCrmCustomsChargesFclExport([])
                            setCrmCustomsChargesFclImport([])
                            setCrmCustomsChargesAirExport([])
                            setCrmCoLoaderFrightCharges([])
                            setCrmExportCoLoaderLocalCharges([])
                            setCrmImportCoLoaderLocalCharges([])
                            setCrmAirLineFrieghtChargesExport([])
                                setCrmAirLineFrieghtChargesImport([])
                           // }, 1)
                            window.setTimeout(function () {
                                setImports(value.functionId);
                                bReset = false;
                               // procesCharges(handleAgentLocalChargesLCLImport);
                                onHandleCancelModalCopy()
                            }, 0)
                            
                        }}>
                            Ok
                        </Button>
                        <Button variant='contained' sx={{ mt: 2 }} color='secondary' onClick={onHandleCancelModalCopy}>
                            Cancel
                        </Button>
                    </Grid>}
                </Dialog>

                <Grid container item justifyContent='flex-end' lg={22}>
                    <Button variant='contained' sx={{ mt: 2, mr: 2 }} onClick={() => {
                        onHandleOpenModalCopy()
                        
                    }}>
                        Reset Charges
                    </Button>
                    <Button variant='contained' sx={{ mt: 2, mr: 2 }} onClick={ save}>
                        Save
                    </Button>
                    <Button variant='contained' sx={{ mt: 2 }} color='secondary' onClick={props.onHandleCancel}>
                        Cancel
                    </Button>
                </Grid>
                    </Grid>

            {snackbar && (
                <Snackbar open={!!snackbar} message={snackbar.message} type={snackbar.type} onClose={onSnackbarHandleClose} />
            )}
            </Grid>
            
    );
};

export default AddCrm;
